export enum MOBILE_LINKS {
  LEGAL = 1,
  SETTINGS = 2,
  PRIVACY = 3,
}
